import { Model } from "../../model";
import { Book } from "./book";

export interface Reader {
  book: Book;
}

export const createReader = (model: Model): Reader => {
  return {
    book: new Book(model),
  };
};
